import * as React from 'react';
import { StyledProgressBarRoot, StyledProgressBarIndicator } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const ProgressBar = React.forwardRef(({
  size,
  backgroundColor,
  foregroundColor,
  min = 0,
  max,
  value
}, ref) => {
  return jsx(StyledProgressBarRoot, {
    ref: ref,
    size: size,
    backgroundColor: backgroundColor,
    "aria-valuemin": min,
    children: jsx(StyledProgressBarIndicator, {
      foregroundColor: foregroundColor,
      max: max,
      min: min,
      value: value
    })
  });
});

export { ProgressBar };
